import { useEffect, useState } from 'react';
const KEY = 'aeon_research_theme';
function readTheme() { try { const value = localStorage.getItem(KEY); return ['dark','light','auto'].includes(value) ? value : 'dark'; } catch { return 'dark'; } }
export function useResearchTheme() {
  const [theme, setTheme] = useState(readTheme);
  useEffect(() => {
    const sync = () => setTheme(readTheme());
    window.addEventListener('aeon:research-theme',sync); window.addEventListener('storage',sync);
    return () => { window.removeEventListener('aeon:research-theme',sync); window.removeEventListener('storage',sync); };
  },[]);
  function changeTheme() {
    const next = theme === 'dark' ? 'light' : theme === 'light' ? 'auto' : 'dark';
    setTheme(next);
    try { localStorage.setItem(KEY,next); window.dispatchEvent(new Event('aeon:research-theme')); } catch { /* usable without persistence */ }
  }
  return [theme,changeTheme];
}
